"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _RetrieveUserIdStepResponse = _interopRequireDefault(require("../../api/auth/RetrieveUserIdStepResponse"));
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
const decorateSuccessMessage = msg => /*#__PURE__*/_react.default.createElement("div", {
  className: "field"
}, /*#__PURE__*/_react.default.createElement("div", {
  className: "control is-expanded has-icons-left"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "has-text-left"
}, msg)));
class RetrieveUserIdStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      secret: '',
      errorMessage: '',
      message: '',
      workflowComplete: false
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  submit(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _RetrieveUserIdStepResponse.default();
    step.secret = Buffer.from(this.state.secret).toString('base64');
    this.props.listener(this, step);
  }
  change(e) {
    const secret = e.target.value;
    if (!this.validateLength(secret)) {
      this.setState({
        secret,
        errorMessage: 'This field is required for submission'
      });
    } else {
      this.setState({
        secret,
        errorMessage: null
      });
    }
  }
  validate(secret) {
    return this.validateLength(secret);
  }
  validateLength(secret) {
    return secret && secret.length > 0;
  }
  returnToLogin(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    const {
      secret,
      rawErrorMessage,
      isLoading,
      workflowComplete,
      message
    } = this.state;
    const disabled = !this.validate(secret) && !rawErrorMessage;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "retrieveUserIdForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title"
    }, "Retrieve User ID"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }), workflowComplete && message ? decorateSuccessMessage(message) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${rawErrorMessage && 'is-danger'}`,
      type: "password",
      placeholder: "Enter your current password",
      id: "secret",
      name: "secret",
      size: "15",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      value: secret,
      autoComplete: "current-password",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), decorateErrorMessage(rawErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Submit")))), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    })))));
  }
}
RetrieveUserIdStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(RetrieveUserIdStep);
//# sourceMappingURL=RetrieveUserIdStep.js.map